import { Modal } from 'react-bootstrap';
import UserStatusWithdrawalLimits
    from '../../UserStatus/components/UserStatusWIthdrawalLimits/UserStatusWithdrawalLimits';
import { WithdrawalLimitsModalContainerStyled } from './styled/WithdrawalLimitsModalStyled';

function WithdrawalLimitsModal() {
    return <>
        <Modal.Header closeButton/>
        <WithdrawalLimitsModalContainerStyled className={'custom-scrollbar'}>
            <UserStatusWithdrawalLimits/>
        </WithdrawalLimitsModalContainerStyled>
    </>;
}

export default WithdrawalLimitsModal;
